import dayjs from 'dayjs';
import { DD_MM_YYYY } from 'utils/constants/date-time';

export const formatDate = (dateString: string, format?: string): string => dayjs(dateString)
	.format(format || DD_MM_YYYY);
